import { useEffect, useRef, useState } from "react";
import { CrossStorageClient } from "cross-storage";
import { env } from "@/shared/config";
import { TokenManipulate } from "../session-service";

const RETRY_DELAYS_MS = [2000, 5000, 10000];

const storage = new CrossStorageClient(env.OLD_FRONTEND_URL, { timeout: 10000 });

export const useAuth = () => {
  const [isAuth, setIsAuth] = useState(false);
  const [isProcessing, setIsProcessing] = useState(true);
  const [isError, setIsError] = useState(false);
  const attemptRef = useRef(0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const checkAuth = () => {
      storage
        .onConnect()
        .then(() => storage.get("token", "REALM"))
        .then((tokens) => {
          const token = tokens[0];
          if (token === null) {
            return Promise.reject(new Error("Token is null"));
          }

          if (tokens[1] !== null) {
            localStorage.setItem("REALM", tokens[1]);
          }

          const localToken = localStorage.getItem("token");
          if (localToken !== token) {
            TokenManipulate.print({ token });
            localStorage.removeItem("newToken");
            localStorage.removeItem("newIat");
            localStorage.removeItem("iat");
          }

          setIsAuth(true);
          setIsProcessing(false);
        })
        .catch(() => {
          const attempt = attemptRef.current;
          if (attempt < RETRY_DELAYS_MS.length) {
            attemptRef.current += 1;
            timerRef.current = setTimeout(checkAuth, RETRY_DELAYS_MS[attempt]);
          } else {
            TokenManipulate.remove();
            setIsAuth(false);
            setIsError(true);
            setIsProcessing(false);
          }
        });
    };

    checkAuth();

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return {
    isAuth,
    isProcessing,
    isError,
  };
};
